import React from 'react'
import PropTypes from 'prop-types'
import { InputField, LoaderButton } from 'components/molecules'
import { Form, Formik } from 'formik'
import fastSellProductInboundFormInitialValues from './fast-sell-product-inbound-form-initial-values'
import fastSellProductInboundFormSchema from './fast-sell-product-inbound-form-schema'


const propTypes = {
  fastSellProduct: PropTypes.shape({
    id                  : PropTypes.number,
    inbound_courier     : PropTypes.string,
    inbound_shipping_no : PropTypes.string,
    status              : PropTypes.string
  }),
  onClickSubmit : PropTypes.func,
  disabled      : PropTypes.bool
}

const defaultProps = {
  fastSellProduct : {},
  onClickSubmit   : () => { },
  disabled        : false
}

const FastSellProductInboundForm        = ({
  onClickSubmit,
  fastSellProduct,
  disabled
}) => (
  <Formik
    initialValues={ fastSellProductInboundFormInitialValues(fastSellProduct) }
    enableReinitialize={ true }
    validationSchema={ fastSellProductInboundFormSchema }
    onSubmit={ onClickSubmit }
  >
    {
      (formik) => (
        <Form>
          <InputField
            type={ 'text' }
            name={ 'inbound_courier' }
            label={ 'Inbound Courier' }
            placeholder={ 'JNE / Gojek / J&T' }
            formText={ 'Courier yang digunakan pada pengiriman product' }
            disabled={ disabled }
          />
          <InputField
            type={ 'text' }
            name={ 'inbound_shipping_no' }
            label={ 'Inbound Shipping No' }
            formText={ 'No resi pengiriman' }
            disabled={ disabled }
          />

          <div className='text-right'>
            <LoaderButton
              color='primary'
              type='submit'
              disabled={ formik.isSubmitting || disabled }
              isLoading={ formik.isSubmitting }
              text='Update Inbound'
            />
          </div>
        </Form>
      )
    }
  </Formik>
)
FastSellProductInboundForm.propTypes    = propTypes
FastSellProductInboundForm.defaultProps = defaultProps

export default FastSellProductInboundForm
